<template>
  <div class="ranking">
    <div class="top">
      <p>排行榜</p>
      <p>排行数据每10分钟更新一次</p>
    </div>

    <van-tabs >
      <van-tab title="个人排行" >
        <div class="conter">
          <ul>
            <li>名次</li>
            <li  >姓名</li>
            <li>手机号</li>
            <li  >部门</li>
            <li>分数</li>
          </ul>
          <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad"
            :offset="500"
          >
            <van-cell v-for="(item, index) in list" :key="index" class="list">

              <ul :style="{
                backgroundColor:item.webUserId==token?'#F8F8FF':'transparent',
                position:'relative'
              }">
                
                <li>
                  <img class="crown"
                    :src="
                      index == 0
                        ? require('../../assets/stormPassAnswer/one.png')
                        : index == 1
                        ? require('../../assets/stormPassAnswer/two.png')
                        : index == 2
                        ? require('../../assets/stormPassAnswer/three.png')
                        : ''
                    "
                    alt
                  />
                  <span v-if="index > 2">{{ index + 1 }}</span>
                </li>
                <li  >
                  <span>{{ item.webUserName }}</span>
                </li>
                <li>
                  <span>{{ formatNum(item.webUserMobile) }}</span>
                </li>
                <li  >
                  <span>{{ item.webBtDepName }}</span>
                </li>

                <li>{{ item.webScore }}</li>
               
              </ul>
              <img src="../../assets/stormPassAnswer/right3.png" class="right" v-if="item.webUserId==token"/>

            </van-cell>
          </van-list>
        </div>
      </van-tab>
      <van-tab title="部门排行" v-if="$route.query.webRegDepSwh==1">
        <div class="conter2">
          <ul>
            <li>名次</li>
            <li>部门</li>
            <li>分数</li>
          </ul>
          <van-list
            v-model:loading="loading"
            :finished="finished"
            finished-text="没有更多了"
            @load="onLoad2"
            :offset="500"
          >
            <van-cell v-for="(item, index) in list2" :key="index" class="list">
              <ul>
                <li>
                  <img class="crown"
                    :src="
                      index == 0
                        ? require('../../assets/stormPassAnswer/one.png')
                        : index == 1
                        ? require('../../assets/stormPassAnswer/two.png')
                        : index == 2
                        ? require('../../assets/stormPassAnswer/three.png')
                        : ''
                    "
                    alt
                  />
                  <span v-if="index > 2">{{ index + 1 }}</span>
                </li>
                <li>
                  <span>{{ item.webBtDepName }}</span>
                </li>
                <li>{{ item.webScore }}</li>
              </ul>
            </van-cell>
          </van-list>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import { getBreakthroughRankCustom } from '@/api/stormPassAnswer'
import { filePerviewPath } from '@/api/ActivitySolicitation/index.js'
import {  Toast } from 'vant'

export default {
  data() {
    return {
      loading: true, //下拉加载
      loading2: false, //下拉加载
      finished: false,
      active: 0,
      list: [],
      list2: [],
      pageNum: 0,
      pageNum2: 0,
      defaultImg: require('../../assets/img/portrait.png'),
      token:localStorage.getItem("token"),
      webRegNameSwh:'', //姓名
      webRegDepSwh:''  //部门
    }
  },
  mounted() {
    this.onLoad()
    setTimeout(() => {
      this.onLoad2()
    },2000)
   
  },
  methods: {
    formatNum(phoneNumber){
       return phoneNumber?phoneNumber.replace(/^(\d{3})\d{4}(\d{4})$/, '$1****$2'):'';
      
    },
    //下拉加载
    onLoad() {
      this.active=0
      ++this.pageNum
      this.getList()
    },
    onLoad2() {
      this.active=1
      ++this.pageNum2
      this.getList()
    },
    onClick(name, title) {
      // this.active = name
      // this.getList()
      
    },

    getList() {
      getBreakthroughRankCustom({
        pageNum: this.active == 0 ? this.pageNum : this.pageNum2,
        webBtId: this.$route.query.id,
        webBtRankType: this.active,
      }).then(({ data }) => {
        if (data.code == 200) {
          if (data.data.list.length > 0) {
            this.loading = false
            if (this.active == 0) {
              this.list = [...this.list, ...data.data.list]
              this.list.map((ele) => {
                ele.imgpath = filePerviewPath({
                  id: ele.webUserAvatar,
                  type: 'cover',
                })
              })
            } else {
              this.list2 = [...this.list2, ...data.data.list]
              this.list2.map((ele) => {
                ele.imgpath = filePerviewPath({
                  id: ele.webUserAvatar,
                  type: 'cover',
                })
              })
            }
          } else {
            this.finished = true
          }
         
        }else{
          Toast.fail(data.msg)
        }
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.right{
  position:absolute;
  right:0;
  top:0;
  width: 39px;
  height: 17px;
}
.crown{
  width:26px;
  height:26px;
}
/deep/ .van-tabs__wrap {
  height: 52px;
  margin-top: -0.96rem;
  border-radius: 0.32rem 0.32rem 0px 0px;
}
/deep/ .van-tab {
 font-size: 18px;
}

/deep/.van-tabs__line {
  height: 0px;
}
/deep/.van-image {
  width: 0.8rem !important;
  height: 0.8rem !important;
  border-radius: 50% !important;
  margin-right: 0.24rem !important;
  overflow: hidden;
}
/deep/ .van-tab--active {
  color: #5f73f9;
  font-weight: 500;
}
.ranking {
  .top {
    background: url('../../assets/stormPassAnswer/ranking.png') no-repeat;
    background-size: 100%;
    height: 4.08rem;
    padding: 0.8rem 0 1.76rem 0.72rem;
    box-sizing: border-box;
    color: #fff;
    > p:first-child {
      font-weight: 500;
      font-size: 0.76rem;
    }
    > p:last-child {
      font-size: 0.28rem;
      margin-top: 0.08rem;
    }
  }
  .conter {
    ul {
      display: flex;
      font-size: 0.28rem;
      color: #999999;
      background: #fff;
      justify-content: space-around;
      line-height: 0.96rem;
      > li {
        
        text-align: center;
      }
      li:first-child {
        width: 15%;
        img {
          vertical-align: middle;
          margin-bottom: 5px;
        }
      }
      li:nth-child(3),
      li:nth-child(4) {
        width: 25%;
        text-align: left;
        display: flex;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
      li:nth-child(5) {
        width: 10%;
      }
      li:nth-child(2) {
        width: 15%;
        align-items: center;
        text-align: left;
        display: flex;
        overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;

        > span {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .list {
      padding: 0 !important;

      li {
        font-weight: 400;
        color: #333333;
        line-height: 1.52rem;
      }
    }
    .list::after {
      border: none !important;
    }
  }

  .conter2 {
    ul {
      display: flex;
      font-size: 0.28rem;
      color: #999999;
      background: #fff;
      justify-content: space-around;
      line-height: 0.96rem;
      > li {
        text-align: center;
      }
      li:first-child {
        width: 15%;
        img {
          vertical-align: middle;
          margin-bottom: 5px;
        }
      }
      li:nth-child(3),
      li:nth-child(4) {
        width: 25%;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
      }
    
      li:nth-child(2) {
        width: 65%;
        text-align: left;
        display: flex;
        align-items: center;

        > span {
          width: 67%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .list {
      padding: 0 !important;
      font-weight: 400;
      color: #333333;
      li {
        font-weight: 400;
        line-height: 1.52rem;
        color: #333333;
      }
    }
    .list::after {
      border: none !important;
    }
  }
}
</style>
